export default "<div class=\"masonry-headline\" sh-fit-text> {{ post.headline }} </div> ";